import { CustomizeThemeLocalizationEntityLevel } from '../../../enums/CustomizeThemeLocalizationEntityLevel';

export const NotSupportedError = (entityLevel: CustomizeThemeLocalizationEntityLevel): Error => {
  throw new Error(`Not supported entity level ${entityLevel}`);
};
